import { z } from 'zod';
import { TransformInsights } from 'libs/end-to-end/src/types/databases/transform/transform-insights';

export const TransformSucceededDetails = z.object({
  status: z.literal('Succeeded'),
  insights: TransformInsights,
});

export type TransformSucceededDetails = z.infer<
  typeof TransformSucceededDetails
>;
